// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "../css/" + chunkId + "." + {"~~product-configurator":"bd6d1898ae73f8c0a8d5","~~product-configurator-styles":"b008f4eaa40563365290"}[chunkId] + ".css";
};